import { render, staticRenderFns } from "./pageSet.vue?vue&type=template&id=78fc2555&"
import script from "./pageSet.vue?vue&type=script&lang=js&"
export * from "./pageSet.vue?vue&type=script&lang=js&"
import style0 from "./pageSet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports